export const regExp = {
  escapeReturnAndLineFeed: /(?:\r\n|\r|\n)/g,
  alphabetical: /^[a-zA-Z][a-zA-Z\s]*$/,
  onlyNumber: /(^[0-9]+$|^$)/,
  alphaAndNotSpecialChars: /^[a-zA-Z\s'.&]*$/,
  phoneFormat: /^(\d{3})-(\d{3})-(\d{4})$/g,
  number2decimals: /(\.\d{2})\d+/g,
  number3Digits: /\B(?=(\d{3})+(?!\d))/g,
  nonDigit: /[^\d.-]/g,
  capitalize: /(^|[:.!?]\s+)([a-z])/g,
  fieldName: /^[a-zA-Z][a-zA-Z\s.']*$/,
};
